import React, { Component } from 'react';
import { Wrapper } from './styled';
import AdvantegeComponent from '../AdvantegeComponent';
import domofonIco from '~/static/images/domofon/meeting/domofon.svg';
import houseIco from '~/static/images/domofon/meeting/house.svg';
import keyIco from '~/static/images/domofon/meeting/key.svg';
import signalIco from '~/static/images/domofon/meeting/signal.svg';
import smartphoneIco from '~/static/images/domofon/meeting/smartphone.svg';
import cameraIco from '~/static/images/domofon/meeting/camera.svg';


class AdvantegeGroup extends Component {
    render() {
        return (
            <Wrapper>
                <AdvantegeComponent
                    img={cameraIco}
                    title='Скрытую видеокамеру'
                    text='С высоким разрешением и ночным режимом съемки. Вы увидите все, что происходит за дверью, в режиме онлайн' />
                <AdvantegeComponent
                    img={domofonIco}
                    title='Архив видео за неделю'
                    text='Видео с камеры за последние 7 дней записываются на сервер. Вы всегда можете посмотреть, что происходило в ваше отсутствие' />
                <AdvantegeComponent
                    img={smartphoneIco}
                    title='Управление через приложение'
                    text='Открывайте дверь в подъезд не вставая с дивана. Смотрите, кто пришел, даже если вы не дома. Достаточно установить на смартфон приложение «Умный Дом.ру»' />
                <AdvantegeComponent
                    img={keyIco}
                    title='Ключи'
                    text='Привязаны к конкретной квартире. Их нельзя скопировать или подделать, чтобы проникнуть в подъезд' />
                <AdvantegeComponent
                    img={signalIco}
                    title='Кнопку SOS'
                    text='На панели вызова расположена кнопка SOS для моментальной связи со службой «112»' />
                <AdvantegeComponent
                    img={houseIco}
                    title='Экономию на установке'
                    text='Не нужно заменять домофонные сети полностью. Достаточно установить новую панель на двери подъезда' />
            </Wrapper>
        );
    }
}

export default AdvantegeGroup;
